import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cbreak() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  return (
    <div>
       <Sides/>
       <Helmet>
 
 <title>Break statement in c tutorial For Beginners</title>
 <meta name="description" content="break statement in c tutorial for beginners.break statement in c keyword is used to  exit from loop and switch, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c break,break syntax in c,c break statement,c break for loop,c break loop," />
 <link rel="canonical" href="https://www.codeexampler.com/c-break" />
 </Helmet>

 <div className='lg:pl-56'>

      <h1 className="m-4 mh1">Break Statement in c</h1>
     
      <div className="first">
        <a href="/c-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
     
      <h2 className="mt-4 mh2">Main Points of Break in C</h2>
      <p className="mt-4 para">1, Break statement in c keyword is used to  exit from loop and switch :<br />
2, When a break is encountered inside any loop, control automatically passes to the first statement after the loop.<br />
3, Break statement in C is used to terminate a loop immediately. The break statement  is encountered inside a loop<br />
      </p>
    

      <h2 className="headings">Break C syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-10">break </span>
            <span className="qwerty-4">;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>  

      <h2 className="mt-4 mh2">Break In C Examples:</h2>
      {/*2 box*/}



      <h2 className="headings">Q-Write a program loop from 1 to 10 but stop or break when i=5 in the break statement in C?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-6">  if</span>
        <span className="qwerty-4">(</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">==</span>
        <span className="qwerty-1">5</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">  &#123;</span>
        {"\n"}
        <span className="qwerty-2">   break</span>
        <span className="qwerty-4">;</span>
        {"\n"}
        <span className="qwerty-4">  &#125;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>
      
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  <span className="qwerty-10">2</span>                   
                  {"\n"}         
                  <span className="qwerty-1">3</span>                   
                  {"\n"}         
                  <span className="qwerty-10">4</span>                   
                  {"\n"}         
                  {"\n"}
                  </code>
                  </pre>
                  </div>   


      <p className="mt-4 para">If you don't know about input in C so check on the <a href="https://www.codeexampler.com/c-for-loop">C for loop statement tutorial</a>.</p>

   

      <h2 className="headings">Q-Write a program loop from 1 to 10 but stop or break on first even no occur in break statement in C?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-8"> printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">Enter a number</span>
        <span className="qwerty-4">");</span>
            {"\n"}
                <span className="qwerty-6"> scanf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-3">%d</span>
                <span className="qwerty-4">",</span>
                <span className="qwerty-1"> &amp;</span>
                <span className="qwerty-5">num</span>
                <span className="qwerty-4">);</span>
            {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>
        <span className="qwerty-4">;</span>                                   
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-6">  if</span>
        <span className="qwerty-4">(</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">%</span>
        <span className="qwerty-1">2</span>
        <span className="qwerty">==</span>
        <span className="qwerty-1">0</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">  &#123;</span>
        {"\n"}
        <span className="qwerty-2">   break</span>
        <span className="qwerty-4">;</span>
        {"\n"}
        <span className="qwerty-4">  &#125;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-3">%d</span>
        <span className="qwerty-10"> \n</span>
        <span className="qwerty-4">",</span>
        <span className="qwerty-5"> i</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
              {"\n"} 
              {"\n"} 
          </code>
        </pre>
      </div>
      
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">1</span>                   
                  {"\n"}         
                  {"\n"}
                  </code>
                  </pre>
                  </div>  

      <p className="mt-4 para">If you don't know about input in C so check on <a href="https://www.codeexampler.com/c-input">C input tutorial</a>.</p>

    

<h2 className="headings">Q-Write a program loop start from 1 to 10 and print complete but stop or break when i=4 in break statement in C</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
        <code>
            {"\n"}
            <span className="qwerty-7">#include </span>
         <span className="qwerty-4">&#60;</span>
         <span className="qwerty-10">stdio.h</span>
         <span className="qwerty-4">&#62; </span>
                        {"\n"} 
        <span className="qwerty-3">int </span>
        <span className="qwerty-2">main</span>
        <span className="qwerty-4"> ()</span>            
        {"\n"}
        <span className="qwerty-4" >&#123; </span>            
        {"\n"}
        <span className="qwerty-3"> int</span>
        <span className="qwerty-5"> i</span>                     
        <span className="qwerty-4">;</span>                     
        {"\n"}
        <span className="qwerty-6"> for</span>
        <span className="qwerty-4"> (</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty-4">=</span>
        <span className="qwerty-1">1</span>
        <span className="qwerty-4">; </span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">&#60;=</span>
        <span className="qwerty-1">10</span>
        <span className="qwerty-4">;</span>
        <span className="qwerty-5">i</span>
        <span className="qwerty">++</span>                                  
      <span className="qwerty-4">)</span>
        {"\n"} 
        <span className="qwerty-4"> &#123;</span>
        {"\n"}
        <span className="qwerty-6">  if</span>
        <span className="qwerty-4">(</span>
        <span className="qwerty-5">i</span>        
        <span className="qwerty">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">  &#123;</span>
        {"\n"}
        <span className="qwerty-8">   printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">no is 4</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-2">   break</span>
        <span className="qwerty-4">;</span>
        {"\n"}
        <span className="qwerty-8">   printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">this is break</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
        <span className="qwerty-4">  &#125;</span>
        {"\n"}
        <span className="qwerty-8">  printf</span>
        <span className="qwerty-4">("</span>
        <span className="qwerty-10">complete \n</span>
        <span className="qwerty-4">"</span>
        <span className="qwerty-4">);</span>
        {"\n"}
              <span className="qwerty-4"> &#125;</span>
        {"\n"}
        <span className="qwerty-7"> return</span>
        <span className="qwerty-3"> 0</span>
        <span className="qwerty-4">; </span>
            {"\n"}
        <span className="qwerty-4">&#125;</span>
              {"\n"} 
              {"\n"} 
          </code>        
         </pre>
      </div>     
      <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-1">complete</span>                   
                  {"\n"}         
                  <span className="qwerty-1">complete</span>
                  {"\n"}         
                  <span className="qwerty-1">complete</span>
                  {"\n"}         
                  <span className="qwerty-3">no is 4</span>
                  {"\n"}
                  {"\n"}
                  </code>
                  </pre>
                  </div> 


<h1 className="mt-5">  </h1>

<div className="back">
        <a href="/c-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div ></div>
)

}
export default Cbreak;